// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___1ulFO","select":"styles-module__select___1NCkl","labelAndSelect":"styles-module__labelAndSelect___2-LbD"};